import axiosInstance from "./axiosInstance";
import { getUserInfoDetails } from "../utlis";

// US state name to 2-letter abbreviation mapping
const STATE_ABBREV = {
  'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
  'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
  'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
  'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
  'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
  'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
  'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH',
  'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
  'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
  'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY',
  'district of columbia': 'DC',
};

// Reverse lookup: 2-letter code to full state name (title case)
const CODE_TO_STATE = Object.fromEntries(
  Object.entries(STATE_ABBREV).map(([name, code]) => [code, name.replace(/\b\w/g, c => c.toUpperCase())])
);

// Convert full state name to 2-letter code, or return as-is if already abbreviated
const toStateCode = (state) => {
  if (!state) return '';
  if (state.length === 2) return state.toUpperCase();
  return STATE_ABBREV[state.toLowerCase()] || state;
};

// Convert 2-letter state code to full name, or return as-is
export const toStateName = (code) => {
  if (!code) return '';
  if (code.length === 2) return CODE_TO_STATE[code.toUpperCase()] || code;
  return code; // Already a full name
};

/**
 * Validate a US address using USPS via backend API.
 * @param {Object} address - { street, street2, city, state, zip }
 * @returns {Promise<Object>} - { valid, modified, input, standardized, message }
 */
export const validateAddress = async (address) => {
  const { clientId, companyId } = getUserInfoDetails();

  const payload = {
    street: address.street || '',
    street2: address.street2 || '',
    city: address.city || '',
    state: toStateCode(address.state),
    zip: address.zip || '',
  };

  const response = await axiosInstance.post(
    `/validate-address?client=${clientId}&company=${companyId}`,
    payload
  );
  return response.data;
};
